export default __webpack_public_path__ + "static/media/IMG5122.0200809b.jpg";